// @flow weak

import React            from 'react';
import PropTypes        from 'prop-types';
import cx               from 'classnames';
import { Link }         from 'react-router-dom';
import FontIcon         from 'material-ui/FontIcon';
import IconButton       from 'material-ui/IconButton';
import yellowA700       from 'material-ui/styles/colors';

const styles = {
  mediumIcon: {
    width: 48,
    color: '#FFFF'
  },
  medium: {
    width: 96,
    padding: 2,
  },
};

const ViewLink = ({
  isActive,
  linkTo,
  viewName,
  itemCount,
  faIconName
}) => (
  <IconButton tooltip={viewName} containerElement={<Link to={linkTo} />} iconStyle={styles.mediumIcon}
      style={styles.medium}>
    <FontIcon className={`fa ${faIconName}`} hoverColor={yellowA700}/>
  </IconButton>
);

ViewLink.propTypes = {
  isActive:   PropTypes.bool,
  viewName:   PropTypes.string.isRequired,
  linkTo:     PropTypes.string.isRequired,
  faIconName: PropTypes.string.isRequired,
  itemCount:  PropTypes.number
};

ViewLink.defaultProps = {
  isActive: false
};

export default ViewLink;



// WEBPACK FOOTER //
// ./src/app/components/aside/asideLeft/menu/menuLinks/viewLink/ViewLink.js